import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {ObjectContextProvider} from "./context/ObjectContextProvider";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ObjectContextProvider>
    <App />
  </ObjectContextProvider>
);

